<template>
  <div
    v-if="data"
    class="flex flex-col justify-center items-center h-full gap-4 py-5 px-2"
  >
    <img
      v-if="image"
      :src="require(`../../assets/images/empty/${image}`)"
      :class="`w-full ${imgSize}`"
      alt="img-empty"
      loading="lazy"
    />
    <p class="text-xl font-bold">{{ title }}</p>
    <p :class="`text-gray-500 text-center w-100 ${msgSize}`">{{ label }}</p>
  </div>
</template>

<script lang="ts">
import { GenericsUtils } from "@/utils/generics.util";
import { defineComponent } from "vue";
export default defineComponent({
  name: "emptyData",
  computed: {
    generics(): GenericsUtils {
      return new GenericsUtils();
    },
  },
  props: {
    data: {
      type: Boolean,
      default: false,
    },
    title: [String],
    label: {
      type: String,
      default: "Nenhum resultado foi encontrado",
    },
    image: [String],
    imgSize: { type: String, default: "h-64" },
    msgSize: { type: String, default: "md:w-5/12" },
  },
});
</script>
